module.exports = __webpack_public_path__ + "media/images/tigor/tigor3-adb034fb6ff906151bb65617494c2e6d.png";